const $$splitComponentImporter = () => import('/home/runner/work/upple-client-v2/upple-client-v2/src/routes/cm/notification-schedules/$companyId.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute, redirect } from '@tanstack/react-router';
export const Route = createFileRoute('/cm/notification-schedules/$companyId')({
  beforeLoad: ({
    params
  }) => {
    throw redirect({
      to: '/cm/notification-templates/$companyId',
      params: {
        companyId: params.companyId
      }
    });
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component', () => Route.ssr)
});
export function TSRDummyComponent() {
  return null;
}